import invoiceInstance from '../instance'

const createInvoiceConfigs = ({ bic, iban }) => {
	return invoiceInstance.post('/invoiceConfigs', { bic, iban })
}

export default createInvoiceConfigs
